import React, { useEffect, useState } from 'react';
import './Introduction.css';

const leadershipRoles = [
    'Technology & Engineering Leader',
    'Enterprise Architect',
    'Cloud & AI Advisor',
    'Mentor and Educator',
    'Speaker and Thought Leader'
];

const Introduction = () => {
    const featuredBooks = [
        {
            title: 'Python Interview Preparation',
            subtitle: 'Coding challenges and interview preparation.',
            href: 'https://in.bpbonline.com/products/python-interview-preparation',
            cover: 'https://in.bpbonline.com/cdn/shop/files/2539_Epub.jpg?v=1762253596&width=600'
        },
        {
            title: 'Designing Applications for Google Cloud Platform',
            subtitle: 'Cloud architecture and application design.',
            href: 'https://a.co/d/fK81ofF',
            cover: 'https://m.media-amazon.com/images/I/61Egj3ASKSL._SY522_.jpg'
        }
    ];

    const qrCodeImage =
        'https://api.qrserver.com/v1/create-qr-code/?size=64&data=https://cal.com/ashutoshshashi/professional-conversation';

    const [currentRoleIndex, setCurrentRoleIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(
            () => setCurrentRoleIndex((prev) => (prev + 1) % leadershipRoles.length),
            2500
        );
        return () => clearInterval(intervalId);
    }, []);

    const currentRole = leadershipRoles[currentRoleIndex];

    return (
        <section id="introduction" className="intro">
            <div className="intro-inner">
                <div className="intro-left">
                    <h1 className="intro-name">Ashutosh Shashi</h1>
                    <p className="intro-positioning">
                        I help organizations transform complex ideas and technology
                        challenges into scalable digital platforms, high-performing
                        engineering teams, and measurable business outcomes.
                    </p>

                    <div className="intro-role-wrapper">
                        <span key={currentRole} className="intro-role">
                            {currentRole}
                        </span>
                    </div>

                    <div className="intro-proof-grid" aria-label="Professional highlights">
                        <div>
                            <strong>7</strong>
                            <span>Technology books authored</span>
                        </div>
                        <div>
                            <strong>20+</strong>
                            <span>Years across enterprise domains</span>
                        </div>
                        <div>
                            <strong>6</strong>
                            <span>Industries served at scale</span>
                        </div>
                    </div>

                    <div className="intro-pillars">
                        <div className="intro-pillar">
                            <h3>Architecture &amp; Strategy</h3>
                            <p>
                                Target architectures, modernization roadmaps, and enterprise
                                decision frameworks.
                            </p>
                        </div>
                        <div className="intro-pillar">
                            <h3>Cloud, AI &amp; Modernization</h3>
                            <p>
                                Cloud-native platforms, data foundations, and responsible AI
                                adoption.
                            </p>
                        </div>
                        <div className="intro-pillar">
                            <h3>Engineering Leadership</h3>
                            <p>
                                Mentoring engineers, raising delivery quality, and improving
                                technical execution.
                            </p>
                        </div>
                    </div>

                    <div className="intro-contact-card">
                        <h2>Conversations I value</h2>

                        <p className="intro-contact-copy">
                            Speaking, mentoring, architecture reviews, cloud and AI strategy,
                            and thoughtful collaboration with teams building durable systems.
                        </p>

                        <div className="intro-contact-actions">
                            <a
                                href="https://cal.com/ashutoshshashi/professional-conversation"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="intro-cta primary"
                            >
                                Schedule a professional conversation
                            </a>

                            <a
                                href="https://cal.com/ashutoshshashi/professional-conversation"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="intro-qr"
                                aria-label="QR code to schedule a professional conversation"
                            >
                                <img src={qrCodeImage} alt="QR Code to schedule a professional conversation" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="intro-right">
                    <div className="intro-book-card">
                        <div className="intro-badge">Featured Books</div>
                        <h2>Featured Books</h2>
                        <p className="intro-book-sub">
                            Selected works from my technology book portfolio.
                        </p>

                        <div className="intro-featured-books">
                            {featuredBooks.map((book) => (
                                <a
                                    key={book.title}
                                    href={book.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="intro-book-link"
                                >
                                    <img
                                        src={book.cover}
                                        alt={`${book.title} book by Ashutosh Shashi`}
                                        className="intro-book-image"
                                    />
                                    <span>
                                        <strong>{book.title}</strong>
                                        <small>{book.subtitle}</small>
                                    </span>
                                </a>
                            ))}
                        </div>

                        <a href="#publications" className="intro-book-more">
                            Explore all books
                        </a>
                    </div>

                    <div className="intro-email-right">
                        <span className="intro-email-label">Email</span>
                        <a href="mailto:hello@ashutosh.net.in">hello@ashutosh.net.in</a>
                    </div>

                    <div className="intro-linkedin-block">
                        <h3>Follow the ongoing work</h3>
                        <p>
                            Follow for architecture insights, cloud patterns, leadership
                            thoughts, and updates from IT in Focus.
                        </p>

                        <a
                            className="intro-cta secondary intro-linkedin-btn"
                            href="https://www.linkedin.com/comm/mynetwork/discovery-see-all?usecase=PEOPLE_FOLLOWS&followMember=ashutoshshashi"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Follow on LinkedIn
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Introduction;
